import { render, staticRenderFns } from "./SingleSpeciality.vue?vue&type=template&id=3434520b&"
import script from "./SingleSpeciality.vue?vue&type=script&lang=js&"
export * from "./SingleSpeciality.vue?vue&type=script&lang=js&"
import style0 from "./SingleSpeciality.vue?vue&type=style&index=0&id=3434520b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports